import axios from "axios";
import type { Publication } from "../publications.types";

const BASE = process.env.REACT_APP_SERVER_IP;

export type PublicationFormValues = {
  title: string;
  description: string;
  secondaryLinkText: string;
  secondaryLinkUrl: string;
  pdf: File | null;
};

const buildFormData = (values: PublicationFormValues): FormData => {
  const formData = new FormData();
  formData.append("title", values.title);
  formData.append("description", values.description);
  formData.append("secondaryLinkText", values.secondaryLinkText);
  formData.append("secondaryLinkUrl", values.secondaryLinkUrl);
  if (values.pdf !== null) {
    formData.append("pdf", values.pdf);
  }
  return formData;
};

const authHeader = (token: string): { Authorization: string } => ({
  Authorization: `Bearer ${token}`,
});

export const loginRequest = async (password: string): Promise<string> => {
  const response = await axios.post<{ token: string }>(`${BASE}/admin/login`, {
    password,
  });
  return response.data.token;
};

export const fetchPublications = async (): Promise<Array<Publication>> => {
  const response = await axios.get<Array<Publication>>(
    `${BASE}/api/publications`,
  );
  return response.data;
};

export const createPublicationRequest = async (
  token: string,
  values: PublicationFormValues,
): Promise<void> => {
  await axios.post(`${BASE}/admin/publications`, buildFormData(values), {
    headers: authHeader(token),
  });
};

export const updatePublicationRequest = async (
  token: string,
  id: number,
  values: PublicationFormValues,
): Promise<void> => {
  await axios.put(`${BASE}/admin/publications/${id}`, buildFormData(values), {
    headers: authHeader(token),
  });
};

export const deletePublicationRequest = async (
  token: string,
  id: number,
): Promise<void> => {
  await axios.delete(`${BASE}/admin/publications/${id}`, {
    headers: authHeader(token),
  });
};
